/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FilteredQuery } from '../../models/filtered-query';
import { GetSectorsQueryResult } from '../../models/get-sectors-query-result';
import { SortedQuery } from '../../models/sorted-query';

export interface ApiSectorGetAllSectorsGet$Params {
  CategoryId?: string;
  PageNumber?: number;
  PageSize?: number;
  Filters?: Array<FilteredQuery>;
  Sorts?: Array<SortedQuery>;
  SearchTerm?: string;
}

export function apiSectorGetAllSectorsGet(http: HttpClient, rootUrl: string, params?: ApiSectorGetAllSectorsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSectorsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiSectorGetAllSectorsGet.PATH, 'get');
  if (params) {
    rb.query('CategoryId', params.CategoryId, {});
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
    rb.query('Filters', params.Filters, {});
    rb.query('Sorts', params.Sorts, {});
    rb.query('SearchTerm', params.SearchTerm, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetSectorsQueryResult>;
    })
  );
}

apiSectorGetAllSectorsGet.PATH = '/api/Sector/GetAllSectors';
